export interface CustomMealPlan {
  id: string;
  title: string;
  image: string;
  time: string;
  servings: number;
  caloriesPerServing: number;
  ingredients?: Array<string>;
  ingredientsMulti?: Array<string>;
  instructions: Array<string>;
  category: string;
  greenPercentage: number;
  week: string;
}

export const recipes: Array<CustomMealPlan> = [
  {
    id: "pita-party-pizzas",
    title: "Pita Party Pizzas",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/pitapartypizza__HR_crop.png",
    greenPercentage: 78,
    time: "20 mins",
    servings: 2,
    caloriesPerServing: 450,
    ingredients: [
      '2  whole wheat pitas (6" diameter)',
      "1 package (10 ounces) frozen chopped spinach, thawed and squeezed dry",
      ".5 cup shredded mozzarella cheese",
      ".25 cup crumbled feta cheese",
      ".25 cup sliced black olives",
      "1  tomato, diced",
      ".25 cup thinly sliced red onion",
    ],
    instructions: [
      "Preheat the oven to 400\u00b0F.",
      "Prick the pitas several times with a fork. Spread the spinach over the pitas. Sprinkle each with the mozzarella, feta, olives, tomato, and onion. Place the pitas on a baking sheet and bake for 10 minutes.",
      "To serve, cut each pizza into 8 slices.",
    ],
    category: "lunch",
    week: "chow",
  },
  {
    id: "turkey-cheddar-tacos",
    title: "Turkey Cheddar Tacos",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/turkey-cheddar-tacos.jpg",
    time: "15 mins",
    servings: 4,
    caloriesPerServing: 196,
    greenPercentage: 11,
    ingredients: [
      "1 cup shredded cooked turkey breast",
      "2 tbsp. drained pickled jalapeno",
      "1 tbsp. fat-free mayonnaise",
      "Small bunch fresh cilantro",
      "1 lime",
      "4 6-inch fat-free flour tortillas",
      "1 cup shredded lettuce",
      "1 cup cherry tomatoes",
      "1/2 cup shredded reduced-fat cheddar cheese",
    ],
    instructions: [
      "Chop the cilantro to yield about 2 tbsp. chopped. Zest and juice the lime. Halve or quarter the cherry tomatoes (depending on size and your preference).",
      "Combine the turkey, pickled jalapeno, mayonnaise, cilantro, lime zest, and lime juice in a medium bowl.",
      "Warm a large, nonstick skillet over medium-high heat. Add the tortillas, one at a time, and warm until crispy and dark brown in spots, about 1 minute on each side.",
      "Top each tortilla with 1/4 cup of the turkey mixture, spreading it almost to the edge; top with 1/4 cup of lettuce, about 1/4 cup of the tomatoes, and 2 tbsp. of the cheddar.",
    ],
    category: "lunch",
    week: "chow",
  },
  {
    id: "grilled-buffalo-chicken-quesadillas",
    title: "Grilled Buffalo Chicken Quesadillas",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-11/grilled-buffalo-chicken.jpg",
    time: "25 mins",
    servings: 6,
    caloriesPerServing: 285,
    greenPercentage: 11,
    ingredients: [
      "2 Boneless Skinless Chicken Breasts",
      "2 tsp Olive Oil",
      "2 tsp Table Salt",
      "2 tsp Black Pepper",
      "2 tbsp Coconut Oil",
      "1/4 cup Frank's Red Hot Sauce",
      "6 oz Fage Total 0% Yogurt Greek Strained All Natural-Nonfat",
      "1 clove Raw Garlic",
      "2 tbsp Lemon Juice",
      "1/4 cup Celery",
      "1/2 cup (sliced) Red Onion",
      "1 cup Real Cheese Light Shredded Cheddar",
      "6 Whole Wheat Tortilla",
    ],
    instructions: [
      "Fire up an indoor grill pan or charcoal grill.",
      "Place the chicken breasts on a work surface. Drizzle with olive oil and season with salt and pepper. Grill over medium-high heat, for 4 minutes on each side, rotating 90 degrees halfway through cooking to get a nice crosshatch. Allow the chicken to rest until cool enough to touch. Finely chop the chicken and add to a mixing bowl along with the coconut oil and hot sauce. Toss to combine and taste for seasoning.",
      "Meanwhile, in a medium bowl, combine the yogurt, garlic, lemon juice, and 1/2 teaspoon sea salt. Whisk until smooth.",
      "To assemble the quesadillas, arrange the tortillas on a clean work surface. Slather one side of each with a scant tablespoon of the yogurt sauce. Arrange a thin layer of the chicken mixture on one half of the tortillas. Top with onions and cheese. Fold the tortillas in half.",
      "Grill the tortillas until crispy and charred, about 2 minutes per side, rotating 90 degrees halfway through to get a nice crosshatch. Cut in half and serve alongside the remaining yogurt sauce.",
    ],
    category: "lunch",
    week: "chow",
  },
  {
    id: "mexican-beef-taco-salad",
    title: "Mexican Beef Taco Salad",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/taco_salad_HR_crop.png",
    time: "17 mins",
    servings: 8,
    caloriesPerServing: 235,
    greenPercentage: 10,
    ingredients: [
      "1 pound 85% lean ground beef",
      "1 package (3/4 ounce) taco seasoning",
      ".25 cup water",
      "1 head romaine lettuce, chopped",
      "1 can (11 ounces) corn, drained",
      "2  tomatoes, chopped",
      "1  small jar (8 ounces) low-fat Catalina salad dressing",
      "1 package (8 ounces) baked tortilla chips, crushed",
    ],
    instructions: [
      "Coat a large, nonstick skillet with cooking spray and place it over medium-high heat. Add the beef and cook for 5 minutes, or until it's browned. Drain any accumulated fat and add the taco seasoning and water. Stir until the mixture begins to thicken. Remove from the heat.",
      "In a large bowl, combine the lettuce, corn, tomatoes, and dressing. Toss gently to coat. Top with the meat and the chips just before serving.",
    ],
    category: "lunch",
    week: "chow",
  },
  {
    id: "roasted-sweet-potato-salad",
    title: "Roasted Sweet-Potato Salad",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/SweetPotSalad_HR_crop.png",
    time: "52 mins",
    servings: 4,
    caloriesPerServing: 303,
    greenPercentage: 94,
    ingredients: [
      "2 tablespoons olive oil",
      ".25 teaspoon salt",
      ".25 teaspoon freshly ground black pepper",
      '2 pounds sweet potatoes, scrubbed and cut into 1" chunks',
      '2  large red bell peppers, cut into 1" pieces',
      "2 tablespoons white balsamic or white wine vinegar",
      "1 pound spinach or arugula, torn into bite-size pieces",
    ],
    instructions: [
      "Preheat the oven to 425\u00b0F.",
      "In a large roasting pan, combine the oil, salt, and black pepper. Add the sweet potatoes and bell peppers and toss to coat well. Roast, stirring occasionally, for 40 minutes, or until the potatoes are tender. Remove from the oven and stir in the vinegar.",
      "Place the spinach or arugula in a large serving bowl. Add the potato mixture and toss to coat well. Serve immediately.",
    ],
    category: "lunch",
    week: "chow",
  },
  {
    id: "grilled-tomato-and-cheese-sandwiches",
    title: "Grilled Tomato and Cheese Sandwiches",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/00124810_HR_crop.png",
    time: "12 mins",
    servings: 4,
    caloriesPerServing: 302,
    greenPercentage: 19,
    ingredients: [
      "8  slices multigrain bread",
      "8  slices low-fat jarlsberg or cheddar cheese",
      "1  large tomato, cut into 8 slices",
      "2  roasted red peppers,halved",
      "12  large leaves fresh basil",
    ],
    instructions: [
      "Coat both sides of the bread with olive oil-flavored cooking spray. In a large nonstick skillet over medium heat, cook the bread on 1 side for 2 minutes, or until lightly toasted. Do this in batches, if necessary. Remove from the pan.",
      "Arrange 4 of the slices, toasted side up, on a work surface. Top with the cheese, tomato, peppers, and basil. Top with the remaining bread slices, toasted sided down.",
      "Carefully place the sandwiches in the skillet. Cook for 2 minutes per side, or until toasted and the cheese melts.",
    ],
    category: "lunch",
    week: "chow",
  },
  {
    id: "fruited-turkey-salad",
    title: "Fruited Turkey Salad",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/P_TURKSAL_30_HR_crop.png",
    time: "15 mins",
    servings: 4,
    caloriesPerServing: 327,
    greenPercentage: 22,
    ingredients: [
      ".5 cup (4 ounces) fat-free sour cream",
      ".25 cup low-fat mayonnaise",
      "2 teaspoons chopped fresh thyme or 1 teaspoon dried, crushed",
      "2 teaspoons lemon juice",
      ".5 teaspoon grated lemon peel",
      '1 pound cooked skinless turkey breasts, cut into 1/2" cubes',
      "2  ribs celery, chopped",
      '1  apple, cut into 1/2" cubes',
      ".333 cup dried apricots, sliced",
      ".25 cup toasted coarsely chopped walnuts",
    ],
    instructions: [
      "In a large bowl, combine the sour cream, mayonnaise, thyme, lemon juice, and lemon peel. Add the turkey, celery, apple, and apricots. Toss gently to coat. Sprinkle with the walnuts.",
    ],
    category: "lunch",
    week: "yumm",
  },
  {
    id: "asian-orzo-and-shrimp",
    title: "Asian Orzo And Shrimp",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/00371278_HR_crop.png",
    time: "15 mins",
    servings: 6,
    caloriesPerServing: 483,
    greenPercentage: 80,
    ingredients: [
      "2 tablespoons soy sauce",
      "2 tablespoons honey",
      "2 tablespoons rice vinegar or lemon juice",
      "1 tablespoon toasted sesame oil",
      "1.5 pounds medium shrimp, peeled and deveined",
      "2 cups orzo",
      "1  large red or green bell pepper, thinly sliced",
      '6  scallions, cut into 3/4" lengths',
      "3  cloves garlic, minced",
      "2 teaspoons grated fresh ginger",
    ],
    instructions: [
      "In a medium bowl, combine the soy sauce, honey, vinegar or lemon juice, 2 teaspoons of the oil, and the shrimp. Set aside to marinate for 10 minutes.",
      "Meanwhile, prepare the orzo according to package directions.",
      "Using a slotted spoon, remove the shrimp from the marinade. Place in a small bowl. Reserve the marinade.",
      "Heat the remaining 1 teaspoon oil in a large nonstick skillet over medium-high heat. Add the shrimp, pepper, scallions, garlic, and ginger. Cook, stirring frequently, for 3 minutes. Stir in the orzo and the reserved marinade. Cook for 2 minutes, or until the shrimp are opaque and cooked through.",
    ],
    category: "lunch",
    week: "yumm",
  },
  {
    id: "mediterranean-turkey-sandwich",
    title: "Mediterranean Turkey Sandwich",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2013-05-30/Mediterranean-Turkey-Sandwich.jpg",
    time: "15 mins",
    servings: 4,
    caloriesPerServing: 347,
    greenPercentage: 63,
    ingredients: [
      "3 tablespoons nonfat mayonnaise",
      "1 tablespoon sun-dried tomato paste",
      "8 thin slices multi grain bread",
      "6 ounces oven-roasted or smoked sliced deli turkey breast, about 8 slices",
      "1/2 avocado, peeled and pitted",
      "1/2 large cucumber, unpeeled",
      "1/2 cup roasted red bell pepper strips",
      "1 cup baby spinach",
    ],
    instructions: [
      "Stir the mayonnaise and tomato paste together.",
      "Spread 1 tablespoon of the mayonnaise mixture on each 4 slices of the bread. Divide the turkey among the bread slices.",
      "Cut the avocado and cucumber 8 slices each. Top the turkey with 2 slices of avocado and cucumber.",
      "Divide the pepper strips among the 4 sandwiches. Top each with 1/4 cup spinach and a slice of multi grain bread.",
    ],
    category: "lunch",
    week: "yumm",
  },
  {
    id: "moms-chicken-noodle-soup",
    title: "Mom's Chicken Noodle Soup",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/chicken-noodle-soup.jpg",
    time: "45 mins",
    servings: 6,
    caloriesPerServing: 269,
    greenPercentage: 28,
    ingredients: [
      "6 cups low-sodium chicken broth",
      "1 tsp. fresh thyme, or 1/4 tsp. dried",
      "2 bay leaves",
      "1 lb. boneless, skinless chicken breasts",
      "Salt and pepper",
      "1 tbsp. vegetable oil",
      "1 onion",
      "2 carrots",
      "1 celery rib",
      "4 oz. thin egg noodles (about 2 cups uncooked)",
      "Small bunch fresh parsley",
    ],
    instructions: [
      "Wash and dry all the produce. Peel the carrots and cut the carrots and celery into 1/4-inch thick slices. Mince the onion. Chop the parsley to yield about 2 tbsp. chopped.",
      "Bring broth, thyme, and bay leaves to a boil in a large saucepan. Once boiling, cover and turn off the heat to maintain temperature without boiling off too much liquid.",
      "Meanwhile, pat chicken dry with paper towels, then season with salt and pepper. Heat oil in large Dutch oven over medium-high heat until just smoking. Add chicken and cook until lightly browned on both sides but not cooked through, about 5 minutes. (To speed up cook time later on you can purchase cutlets or cut your breasts down to cutlets yourself.) Transfer chicken to plate.",
      "Save the chicken drippings in the dutch oven and add the onion and 1/2 tsp. salt. Cook over medium-high heat until lightly browned, about 5 minutes.",
      "Turn heat to low and stir in hot broth mixture, scraping up any browned bits. Add carrots, celery, and browned chicken. Simmer, covered, until chicken is cooked through and no longer pink in center, about 10 minutes.",
      "Remove chicken from pot and stir in noodles. Increase heat to medium-high and cook until noodles are just tender, about 5 minutes",
      "While noodles cook, shred chicken into bite-sized pieces. Turn off the heat, remove bay leaves and stir in shredded chicken and parsley. Season with salt and pepper to taste and serve.",
    ],
    category: "lunch",
    week: "yumm",
  },
  {
    id: "tuscan-style-pasta-with-chicken",
    title: "Tuscan-Style Pasta with Chicken",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/Mens-Health-019_HR_crop.png",
    time: "28 mins",
    servings: 2,
    caloriesPerServing: 400,
    greenPercentage: 4,
    ingredients: [
      "2 oz penne pasta",
      "2  chicken breasts, 4--5 oz each, pounded to an even 1/4'' thickness",
      "4 C baby spinach leaves",
      "1 C cannellini beans, rinsed",
      "Salt and pepper to taste",
      "1 tsp olive oil",
      "1  clove garlic, crushed",
      ".5 tsp dried rosemary, finely chopped",
      "2 tbsp diced roasted red bell pepper",
      "2 tbsp grated parmesan",
    ],
    instructions: [
      "Boil 1 1/2 qt water, drop in the penne, stir, and cook until the pasta is al dente (about 9 to 11 minutes).",
      "While the pasta cooks, sear the chicken in a skillet on medium-high (about 4 to 5 minutes per side), seasoning each side with a pinch of salt and pepper as the other side cooks. Remove the chicken from the skillet and set it aside.",
      "Reduce skillet heat to medium. Add the spinach, beans, oil, garlic, rosemary, and bell peppers. Turn frequently until the spinach wilts (about 1 to 2 minutes).",
      "Slice the chicken and toss it with drained pasta and the spinach and bean mixture. Top each serving with 1 Tbsp of the  cheese.",
    ],
    category: "lunch",
    week: "yumm",
  },
  {
    id: "pizza-meat-subs",
    title: "Pizza-Meat Subs",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/2ND_PIZZAMEA_1_HR_crop.png",
    time: "25 mins",
    servings: 1,
    caloriesPerServing: 746,
    greenPercentage: 2,
    ingredients: [
      "1 lb frozen precooked lean meatballs (from the frozen meat case)",
      "1 can 15-oz pizza sauce",
      "1 can 4-oz sliced mushrooms, drained",
      "4  sub rolls",
      "4  slices reduced-fat provolone cheese",
    ],
    instructions: [
      "HOW TO MAKE IT: Dump the meatballs, sauce, and mushrooms into a large saucepan. Stir to coat the meatballs and 'shrooms with sauce. Cook over medium-low heat until the sauce bubbles and the meatballs are heated through, 20 to 25 minutes. For each sub, line a roll with a slice of cheese and pile on 3 or 4 meatballs and some sauce.",
    ],
    category: "lunch",
    week: "yumm",
  },
  {
    id: "guilt-free-alfredo-pizza",
    title: "Guilt-Free Alfredo Pizza",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/GuiltFreeAlfredoPizza_HR_crop.png",
    time: "20 mins",
    servings: 4,
    caloriesPerServing: 285,
    greenPercentage: 3,
    ingredients: [
      "2 teaspoons olive oil",
      "1 teaspoon minced garlic",
      "1 bag (6 ounces) fresh baby spinach",
      '4  low-fat flour tortillas (7" diameter)',
      "3 tablespoons grated Parmesan cheese",
      "1 can  (5-6 ounces) white chicken meat, drained,",
      "3 slices turkey bacon, cooked and crumbled",
      ".75 cup (3 ounces) shredded mozzarella cheese",
    ],
    instructions: [
      "Preheat the oven to 400\u00b0F.",
      "In a nonstick skillet over low heat, warm the oil and garlic for about 1 minute, or until the garlic sizzles. Add the spinach. Cook, tossing, for about 2 minutes, or until wilted.",
      "Set the tortillas in a single layer on a baking sheet. Sprinkle each with the Parmesan cheese. Cover with an even layer of the spinach and chicken. Top each pizza with the bacon. Sprinkle the mozzarella on top.",
      "Bake for 7 to 10 minutes, or until the cheese is bubbly. Cut each pizza into wedges.",
    ],
    category: "lunch",
    week: "guac",
  },
  {
    id: "soba-noodles-with-almond-sauce-and-shredded-chicken",
    title: "Soba Noodles with Almond Sauce and Shredded Chicken",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/072890_ChickenSoba_HR_crop.png",
    time: "30 mins",
    servings: 4,
    caloriesPerServing: 449,
    greenPercentage: 20,
    ingredients: [
      ".25 cup almond butter",
      "2 tablespoons honey",
      "2 teaspoons reduced-sodium soy sauce",
      "2 teaspoons rice vinegar",
      "6 ounces soba noodles",
      "2 cups shredded cooked chicken breast",
      ".75 cup grated carrots",
      ".5  yellow bell pepper, very thinly sliced (about 2/3 cup)",
      ".25 cup sliced almonds, toasted",
      "8  scallions, white and some green, thinly sliced (about 1/2 cup)",
      "3  radishes, very thinly sliced (about 1/3 cup)",
      "2 tablespoons chopped cilantro",
    ],
    instructions: [
      "Whisk together the almond butter, honey, soy sauce, vinegar, and 2 tablespoons water in a small bowl.",
      "Bring a large pot of water to a boil on high heat. Add the noodles and cook per package directions. Place in a colander, rinse with cold water, and drain thoroughly.",
      "Combine the noodles and the almond butter mixture in a large bowl, tossing to coat. Stir in the chicken, carrots, bell pepper, almonds, scallions, radishes, and cilantro. Divide among 4 bowls and serve.",
    ],
    category: "lunch",
    week: "guac",
  },
  {
    id: "buffalo-meatball-sandwich",
    title: "Buffalo Meatball Sandwich",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/071972_BisonBallSand_HR_crop.png",
    time: "25 mins",
    servings: 4,
    caloriesPerServing: 572,
    greenPercentage: 6,
    ingredients: [
      "1 pound lean ground buffalo",
      "2  egg whites",
      ".5 cup toasted wheat germ",
      ".333 cup finely chopped onion",
      "2 tablespoons grated Parmesan cheese",
      "1 teaspoon minced garlic",
      "1  french baguette or crusty italian bread",
      "1 tablespoon extra-virgin olive oil",
      "1 jar (14 ounces) spaghetti sauce",
      ".5 teaspoon salt-free all-purpose seasoning",
      ".25 teaspoon black pepper",
      "4  thin slices mozzarella cheese",
    ],
    instructions: [
      "Preheat the oven to 350\u00b0F.",
      "Mix the buffalo, egg whites, wheat germ, onion, Parmesan, and garlic. Shape into 12 meatballs and place in a baking dish that's been lightly coated with cooking spray. Bake for 15 to 20 minutes (turning once) or until cooked through.",
      "While the meatballs are cooking, slice the baguette in half lengthwise and remove some of the interior bread to trim the carbs and make room for the meatballs. With 5 minutes left to bake the meatballs, place the bread in the oven to lightly toast. After you do that, brush the meatballs with the oil and season with the all-purpose seasoning and pepper.",
      "Warm the spaghetti sauce in a pan over medium heat. Spoon the meatballs into the sauce to coat and then line them up in the bottom bread half. Top with the mozzarella.",
      "Return the baguette to the oven for about 2 minutes or until the cheese melts. Allow to cool for a minute and cut into slices.",
    ],
    category: "lunch",
    week: "guac",
  },
  {
    id: "hot-n-sour-sausage-sandwiches",
    title: "Hot'n'Sour Sausage Sandwiches",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/2ND_HOTSOURS_1A_HR_crop.png",
    time: "20 mins",
    servings: 1,
    caloriesPerServing: 301,
    greenPercentage: 43,
    ingredients: [
      "4 refrigerated fully cooked chicken sausages",
      "1 can 15-oz sauerkraut, drained",
      "1 can 4-oz chopped green chiles, drained",
      "4  hot dog rolls",
      ".5 cup sliced onions",
      ".5 cup sliced red bell pepper",
      "2 tsp balsamic vinegar,",
      "2 tbsp apple cider or juice",
      ".25 tsp ground black pepper",
      "2 tbsp honey mustard",
    ],
    instructions: [
      "HOW TO MAKE IT: Cook the sausages in a 10\" nonstick skillet over medium heat for 5 minutes, or until browned all over. Remove to a plate. Put the onions and bell peppers in the skillet, cover, and cook for 3 to 4 minutes, or until softened. Stir in the kraut, chiles, vinegar, cider or juice, and black pepper. Simmer for 2 minutes. Return the sausages to the pan and reduce the heat to low. Cover and simmer for a few minutes (or if you're gearing up for a party, let it stew on very low for up to 2 hours). Slap a sausage into a roll with all the fixin's. Top with a thick band of honey mustard.",
    ],
    category: "lunch",
    week: "guac",
  },
  {
    id: "zucchini-rotini-II",
    title: "Zucchini Rotini II",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/PSFBOLIV_04_HR_crop.png",
    time: "18 mins",
    servings: 2,
    caloriesPerServing: 203,
    greenPercentage: 12,
    ingredients: [
      ".25 cup whole wheat rotini pasta",
      ".75 cup 1% cottage cheese",
      "1 tbsp salt-free italian seasoning",
      ".5 cup shredded zucchini",
      "1 cup canned no-salt-added diced tomatoes, drained",
      ".25 cup shredded reduced-fat mozzarella cheese",
      "20  kalamata olives, sliced (about 2/3 cup)",
    ],
    instructions: [
      "Prepare pasta according to package directions. Drain well and set aside. Combine cottage cheese and Italian seasoning in microwaveable dish. Stir in pasta and zucchini. Top with tomatoes and sprinkle with mozzarella. Microwave on high 3 minutes, or until warmed through. Divide pasta evenly between 2 bowls and sprinkle olives on top.",
    ],
    category: "lunch",
    week: "guac",
  },
  {
    id: "roasted-orange-tilapia-and-asparagus",
    title: "Roasted Orange Tilapia and Asparagus",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/Talapia_Quinoa__HR_crop.png",
    time: "20 mins",
    servings: 4,
    caloriesPerServing: 190,
    greenPercentage: 90,
    ingredients: [
      ".25 cup orange juice",
      "1.5 tablespoons olive oil",
      "2 teaspoons minced garlic (about 2-3 medium cloves)",
      "1.5 teaspoons herbes des Provence",
      ".25 teaspoon salt",
      ".25 teaspoon ground black pepper",
      "1 pound tilapia fillets",
      "12 ounces asparagus, trimmed",
      "orange slices",
    ],
    instructions: [
      'Preheat the oven to 375\u00b0F. Coat a 13" x 9" baking dish with cooking spray. Add the orange juice, oil, garlic, herbes de Provence, salt, and pepper. Stir to mix. Place the fish in the pan.',
      'Cut the asparagus into 1 1/2"-long pieces. Place in the pan around the fish. Flip the fish twice and stir the asparagus to thoroughly coat with the orange mixture.',
      "Bake, stirring the asparagus once or twice, for 15 to 20 minutes, or until the fish flakes easily with a fork. Serve garnished with orange slices and drizzled with the pan juices.",
    ],
    category: "lunch",
    week: "guac",
  },
  {
    id: "turkey-sandwich-with-swiss-cheese-and-apple",
    title: "Turkey Sandwich With Swiss Cheese And Apple",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/ssTurkeysandLG_HR_crop.png",
    time: "8 mins",
    servings: 4,
    caloriesPerServing: 407,
    greenPercentage: 26,
    ingredients: [
      "3 tablespoons macadamia or other nut butter",
      "8  slices light whole-wheat bread, lightly toasted",
      "4  slices (1/4 pound) swiss cheese",
      "8  slices (1/2 pound) cooked turkey breast",
      ".25 teaspoon salt",
      ".125 teaspoon ground black pepper (optional)",
      "1  small apple (4 ounces), thinly sliced",
      ".5  bunch watercress sprigs",
    ],
    instructions: [
      "Spread the nut butter over the bread. Arrange the cheese on 4 slices, top with the turkey, and season with the salt and pepper (if using). Top with the apple, watercress or lettuce, and the remaining bread. Cut in half.",
    ],
    category: "lunch",
    week: "eats",
  },
  {
    id: "chicken-salad-with-fennel-lemon-and-parmesan",
    title: "Chicken Salad with Fennel, Lemon, and Parmesan",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/chicken-salad-with-fennel%2C-lemon%2C-and-parmesan.jpg",
    time: "40 mins",
    servings: 4,
    caloriesPerServing: 241,
    greenPercentage: 15,
    ingredients: [
      "1/4 cup reduced fat mayonnaise",
      "1/4 cup 0% Greek yogurt",
      "1/4 cup grated parmesan cheese",
      "2 tbsp. fresh lemon juice",
      "1/4 tsp. grated lemon zest",
      "salt and ground black pepper",
      "2 cups shredded cooked chicken",
      "1/2  fennel bulb, trimmed, cored, and chopped fine",
      "2 tbsp. minced red onion",
      "2 tbsp. minced fresh basil",
      '1/8 cup pine nuts, toasted"',
    ],
    instructions: [
      "Mix mayonnaise, yogurt, parmesan, lemon juice, lemon zest, 1/8 tsp. salt, 1/8 tsp. pepper together in large bowl. Stir in chicken, fennel, onion, and basil until combined. Season with salt and pepper to taste. Let sit 10 minutes to allow flavors to meld. Sprinkle with pine nuts and serve.",
    ],
    category: "lunch",
    week: "eats",
  },
  {
    id: "salmon-patties",
    title: "Salmon Patties",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/salmon_patties_final__HR_crop.png",
    time: "16 mins",
    servings: 4,
    caloriesPerServing: 167,
    greenPercentage: 3,
    ingredients: [
      "1 can (15 ounces) pink salmon, drained, skin removed",
      ".25 cup finely chopped onion or scallions",
      "1  large egg, beaten",
      ".333 cup dried whole wheat bread crumbs or crushed soda crackers",
      ".25 teaspoon ground black pepper",
      "lemon wedges, coarse mustard, or prepared horseradish, for serving",
    ],
    instructions: [
      "In a mixing bowl, combine the salmon, onion or scallions, egg, bread crumbs or crackers, and pepper. With clean hands or 2 forks, mix until blended. Shape into 4 patties.",
      "Coat a large nonstick skillet lightly with cooking spray and warm over medium heat. Place the patties in the pan and cook for about 3 minutes, or until golden on the bottom. Flip and cook for about 3 minutes longer, or until heated through.",
      "Serve with lemon wedges, mustard, or horseradish.",
    ],
    category: "lunch",
    week: "eats",
  },
  {
    id: "smoky-fettuccine-primavera",
    title: "Smoky Fettuccine Primavera",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/00314416_HR_crop.png",
    time: "17 mins",
    servings: 4,
    caloriesPerServing: 506,
    greenPercentage: 10,
    ingredients: [
      "8 ounces fettuccine",
      "1 tablespoon olive oil",
      "2 cups cauliflower florets",
      "2  carrots, thinly sliced",
      "1  small zucchini, quartered and sliced",
      "1  green bell pepper, chopped",
      "1  red bell pepper, chopped",
      "4  cloves garlic, minced",
      "2 teaspoons fresh rosemary",
      ".5 pound cooked ham, chopped",
      ".75 cup chicken broth",
      ".75 cup (3 ounces) coarsely grated smoked gouda cheese",
    ],
    instructions: [
      "Prepare the fettucine according to package directions.",
      "Meanwhile, heat the oil in a large skillet over medium-high heat. Add the cauliflower, carrots, zucchini, bell peppers, garlic, and rosemary. Cook, stirring, for 4 minutes, or until the vegetables are tender-crisp. Add the ham and broth.",
      "Bring to a boil over high heat. Cook for 3 minutes, or until the liquid is slightly reduced.",
      "Place the fettuccine in a serving bowl. Top with the vegetable mixture and the cheese. Toss to coat well.",
    ],
    category: "lunch",
    week: "eats",
  },
  {
    id: "tofu-pad-thai",
    title: "Tofu Pad Thai",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2013-05-30/Tofu-Pad-Thai.jpg",
    time: "30 mins",
    servings: 4,
    caloriesPerServing: 328,
    greenPercentage: 37,
    ingredients: [
      "6 ounces Asian rice noodles",
      "1 cup vegetable broth",
      "2 tablespoons bottled fish sauce",
      "1 tablespoon rice-wine vinegar",
      "1 tablespoon lime juice",
      "3 tablespoons tomato paste",
      "1 tablespoon sugar",
      "1/2 tablespoon seeded, minced jalapeno",
      "1 tablespoon peanut oil",
      "1 teaspoon garlic",
      "1 egg",
      "8 ounces extra-firm tofu, diced into 1/4 inch cubes",
      "1 cup chopped onions",
      "2 1/2 cups fresh bean sprouts",
      "1/2 cup chopped fresh cilantro",
      "1/4 cup chopped, dry-roasted peanuts",
      "4 cups shredded romaine lettuce",
    ],
    instructions: [
      "Prepare the noodles as directed on the package",
      "In a large nonstick skillet or a wok, heat the oil over medium heat and saute the garlic. Add the egg and scramble it into small pieces. Increase the heat to high, add the tofu, and saute 2 minutes, stirring gently. Add the sauce mixture and cook 1 minute, or until it comes to a boil.",
      "Reduce the heat to a medium, and add the rice noodles, onions, sprouts, cilantro, and peanuts to the skillet. Heat thoroughly while tossing until the noodles are coated.",
      "Divide the romaine among 4 plates and serve the Pad Thai over it.",
    ],
    category: "lunch",
    week: "eats",
  },
  {
    id: "giannas-savory-chicken-sandwiches",
    title: "Gianna's Savory Chicken Sandwiches",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/giannas_chicken_sand_HR_crop.png",
    time: "10 mins",
    servings: 6,
    caloriesPerServing: 107,
    greenPercentage: 6,
    ingredients: [
      "1  large can (10 ounces) white chicken",
      "6  baby carrots, diced",
      "1  stalk celery, diced",
      "1  clove garlic, minced",
      ".333 cup italian mild giardiniera, drained and chopped",
      "2 tablespoons diced white onion",
      ".25 cup low-fat or fat-free mayonnaise",
      "salt",
      "ground black pepper",
      "12 slices bread",
      "6  lettuce leaves",
    ],
    instructions: [
      "Drain the chicken and place it in a large bowl. Add the carrots, celery, garlic, Giardiniera, onion, and mayonnaise. Combine well. Salt and pepper to taste.",
      "Cover 1 slice of bread with 1/2 cup of the chicken salad. Add one lettuce leaf and another slice of bread.",
    ],
    category: "lunch",
    week: "eats",
  },
  {
    id: "mango-chicken-salad-with-couscous",
    title: "Mango Chicken Salad with Couscous",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/mango-chicken-salad-with-couscous.jpg",
    time: "45 mins",
    servings: 4,
    caloriesPerServing: 461,
    greenPercentage: 11,
    ingredients: [
      "1/4 cup Moroccan couscous",
      "1 1/2 tbsp finely chopped green bell pepper",
      "1 1/2 tbsp finely chopped red bell pepper",
      "1/4 cup finely chopped red onion",
      "1/2 cup fresh lemon juice",
      "4 tbsp extra-virgin olive oil,",
      "divided",
      "1 tbsp canola oil",
      "4 boneless, skinless chicken breasts (3 oz each)",
      "1/3 cup fresh lime juice",
      "1/4 cup Japanese rice vinegar",
      "2 tbsp whole grain mustard",
      "2 tbsp honey",
      "2 tsp reduced- sodium soy sauce",
      "1/2 head romaine",
      "1/2 head frisee",
      "1/2 head hydro bibb lettuce",
      "1 cup arugula",
      "1/2 mango, thinly sliced",
    ],
    instructions: [
      "In a bowl, combine couscous, bell peppers, onion, lemon juice, 2 tbsp olive oil and 1/3 cup water. Season with salt.",
      "Refrigerate until couscous is tender, about 2 Hours.",
      "In a large skillet over high heat, heat canola oil. Cook chicken until golden brown on the bottom, 3- 4 minutes. reduce heat to medium-low. Flip chicken and cook through, 6 -8 minutes.",
      "Cool chicken; cut into 1/2 inch pieces",
      "In a blender set to medium, blend lime juice, vinegar, mustard, honey and soy sauce. Slowly add remaining 2 tbsp olive oil. Season with salt.",
      "Break up lettuce heads and combine leaves with arugula in a bowl. Divide lettuce, couscous, chicken and mango among 4 plates. Dress salad with mustard vinaigrette.",
    ],
    category: "dinner",
    week: "chow",
  },
  {
    id: "minted-lamb-chops-with-white-beans",
    title: "Minted Lamb Chops With White Beans",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/MintedLambChops_HR_crop.png",
    time: "24 mins",
    servings: 4,
    caloriesPerServing: 384,
    greenPercentage: 6,
    ingredients: [
      "3  anchovy fillets, rinsed and patted dry",
      "1 teaspoon extra-virgin olive oil",
      "3 tablespoons chopped fresh mint or 3 teaspoons dried, crushed",
      ".5 teaspoon freshly ground black pepper",
      "4  lamb loin chops (about 1 1/4 pounds), well-trimmed",
      "4  plum tomatoes, coarsely chopped",
      "1  clove garlic, crushed",
      "3 cups rinsed and drained canned cannellini beans",
      "2 tablespoons beef broth",
      ".25 teaspoon salt",
      "mint sprigs",
      "additional chopped mint for garnish (optional)",
    ],
    instructions: [
      "Coat a broiler-pan rack with cooking spray. Preheat the broiler.",
      "On a cutting board, finely chop the anchovies. Sprinkle with the oil, 1 tablespoon of the fresh mint or 1 teaspoon dried, and 1/4 teaspoon of the pepper, then mash to a paste with the flat side of a chef's knife or a fork. Place the chops on the prepared rack and rub the anchovy paste over both sides of the chops. Let stand at room temperature.",
      "Meanwhile, in a medium nonstick skillet, combine the tomatoes and garlic and cook, stirring frequently, over medium-high heat for 2 minutes, or until the tomatoes begin to give up their juices. Reduce the heat to medium, cover, and cook for 3 minutes, or until the tomatoes are very soft.",
      "Stir in the beans, broth, salt, 2 tablespoons of the remaining fresh mint or 2 teaspoons dried, and the remaining 1/4 teaspoon pepper. Bring to a boil over high heat. Reduce the heat to low, cover, and simmer, stirring occasionally, for 10 minutes to blend the flavors.",
      'While the beans are simmering, broil the lamb chops 4" from the heat for 8 minutes per side, or until a thermometer inserted in the center registers 145\u00b0F for medium-rare.',
      "To serve, evenly divide the bean mixture among 4 plates and top each with a lamb chop. Garnish with the mint, if using.",
    ],
    category: "dinner",
    week: "chow",
  },
  {
    id: "winter-squash-risotto",
    title: "Winter Squash Risotto",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2013-12-05/roasted_squash_risotto.jpg",
    time: "60 mins",
    servings: 4,
    caloriesPerServing: 529,
    greenPercentage: 78,
    ingredients: [
      "5 cups reduced-sodium chicken broth, or vegetable broth",
      "2 tbsp. extra-virgin olive oil",
      "3 medium shallots, thinly sliced",
      "3 cups chopped peeled butternut, hubbard, red kuri or kabocha squash (1/2-inch pieces)",
      "2 cups shiitake mushroom caps, thinly sliced",
      "1/2 tsp. dried thyme",
      "1 cup arborio rice",
      "1/2 cup dry white wine, or dry vermouth",
      "1/2 cup finely grated Parmegiano-Reggiano cheese",
      "salt & pepper, to taste",
    ],
    instructions: [
      "Place broth in a medium saucepan; bring to a simmer over medium-high heat. Reduce heat so the broth remains steaming, but is not simmering.",
      "Meanwhile, heat oil in a large saucepan over medium heat. Add shallots; cook until fragrant, stirring often for about 1 minute. Add in squash and mushrooms; cook, stirring often, until the mushrooms give off their liquid, about 5 minutes. Add thyme, salt and pepper, cook for 30 seconds. Add rice; stir until translucent, about 1 minute. Add wine (or vermouth) and cook, stirring, until almost absorbed by the rice, about 1 minute.",
      "Stir in 1/2 cup of the hot broth; reduce heat to a gentle simmer and cook, stirring constantly, until the liquid has been absorbed. Continue adding the broth 1/2 cup at a time, stirring after each addition until all the liquid has been absorbed, until the rice is tender and creamy, 30 to 40 minutes total. (You may have some broth left.)",
      "Remove from the heat and stir in cheese.",
    ],
    category: "dinner",
    week: "chow",
  },
  {
    id: "grilled-buffalo-chicken-quesadillas",
    title: "Grilled Buffalo Chicken Quesadillas",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-11/grilled-buffalo-chicken.jpg",
    time: "25 mins",
    servings: 6,
    caloriesPerServing: 285,
    greenPercentage: 11,
    ingredients: [
      "2 Boneless Skinless Chicken Breasts",
      "2 tsp Olive Oil",
      "2 tsp Table Salt",
      "2 tsp Black Pepper",
      "2 tbsp Coconut Oil",
      "1/4 cup Frank's Red Hot Sauce",
      "6 oz Fage Total 0% Yogurt Greek Strained All Natural-Nonfat",
      "1 clove Raw Garlic",
      "2 tbsp Lemon Juice",
      "1/4 cup Celery",
      "1/2 cup (sliced) Red Onion",
      "1 cup Real Cheese Light Shredded Cheddar",
      "6 Whole Wheat Tortilla",
    ],
    instructions: [
      "Fire up an indoor grill pan or charcoal grill.",
      "Place the chicken breasts on a work surface. Drizzle with olive oil and season with salt and pepper. Grill over medium-high heat, for 4 minutes on each side, rotating 90 degrees halfway through cooking to get a nice crosshatch. Allow the chicken to rest until cool enough to touch. Finely chop the chicken and add to a mixing bowl along with the coconut oil and hot sauce. Toss to combine and taste for seasoning.",
      "Meanwhile, in a medium bowl, combine the yogurt, garlic, lemon juice, and 1/2 teaspoon sea salt. Whisk until smooth.",
      "To assemble the quesadillas, arrange the tortillas on a clean work surface. Slather one side of each with a scant tablespoon of the yogurt sauce. Arrange a thin layer of the chicken mixture on one half of the tortillas. Top with onions and cheese. Fold the tortillas in half.",
      "Grill the tortillas until crispy and charred, about 2 minutes per side, rotating 90 degrees halfway through to get a nice crosshatch. Cut in half and serve alongside the remaining yogurt sauce.",
    ],
    category: "dinner",
    week: "chow",
  },
  {
    id: "spaghetti-bolognese",
    title: "Spaghetti Bolognese",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2013-12-05/spaghetti.jpg",
    time: "50 mins",
    servings: 4,
    caloriesPerServing: 386,
    greenPercentage: 54,
    ingredients: [
      "1 lb. ground turkey",
      "½ tbsp. extra virgin olive oil",
      "1 medium onion, diced",
      "3 large carrots, peeled and diced",
      "2 celery stalk, diced",
      "1 medium green bell pepper, seeded and chopped",
      "4 medium tomatoes, chopped",
      "4 garlic, minced",
      "1 cup white wine",
      "½ cup chicken broth",
      "½ tbsp. chili flakes",
      "1 tbsp. fresh basil, chopped",
      "1 tbsp. fresh oregano, chopped",
      "1 bay leaf",
      "4 ounce whole wheat pasta",
      "salt and pepper, to taste",
    ],
    instructions: [
      "Cook the pasta according to the package directions.  Drain and keep warm.",
      "Heat olive oil in a pan on medium heat. Add onion, carrots, celery, bell pepper and garlic.  Cook for 5 minutes or until slightly translucent.",
      "Add the ground turkey, tomatoes, basil and oregano. Cook for 10 to 12 minutes or until turkey is fully cooked.",
      "Add white wine and chicken broth and simmer until reduced by half.  Season with bay leaf, chili flakes, and salt & pepper and simmer for 20 minutes.",
      "Serve on whole wheat pasta.",
    ],
    category: "dinner",
    week: "chow",
  },
  {
    id: "ham-mushroom-and-ginger-fried-rice",
    title: "Ham, Mushroom, and Ginger Fried Rice",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/ham-mushroom-and-ginger-fried-rice.jpg",
    time: "30 mins",
    servings: 6,
    caloriesPerServing: 223,
    greenPercentage: 51,
    ingredients: [
      "1 tbsp. canola oil",
      "Fresh ginger",
      "2 cloves garlic",
      "1/2 lb. fresh shiitake mushrooms",
      "1 red bell pepper",
      "1 cup broccoli florets",
      "2 large eggs",
      "2 cups cold, cooked brown rice",
      "1/4 lb. piece lean baked ham",
      "1 cup bean sprouts",
      "1 cup frozen shelled edamame",
      "4 scallions",
      "1/2 tsp. salt",
      "1/4 tsp. pepper",
    ],
    instructions: [
      "Peel and chop the fresh ginger to yield about 1 tsp. Finely chop the garlic. Remove the stems from the shitake mushrooms and slice them. Remove the seeds and veins from the pepper and dice. Break the broccoli florets down into pieces smaller than bite-sized. Dice the ham into 1/4-inch cubes and thinly slice the scallions. Beat the eggs in a small bowl",
      "Heat 2 tsp. of the oil in a large nonstick skillet or wok over medium-high heat until shimmering. Add the ginger and garlic; stir-fry until fragrant, about 30 seconds. Add the mushrooms, bell pepper, and broccoli. Cook, stirring and tossing constantly until the vegetables are crisp-tender and the mushrooms begin to brown, about 5 minutes. Transfer to a medium bowl.",
      "Heat 1 tsp. of the oil in the skillet. Add the eggs and stir-fry until scrambled but still about wet, about 2 minutes. Break up the eggs into small pieces with your spatula and add to the vegetables in the bowl.",
      "Heat the remaining 1 tsp. of oil in the skillet. Add the rice, ham, bean sprouts, edamame, and scallions. Cook, stirring constantly, until heated through, about 3 minutes. Return the vegetables and eggs to the skillet; sprinkle with the salt and pepper. Toss it all together and cook until heated through, about 1 minute.",
    ],
    category: "dinner",
    week: "chow",
  },
  {
    id: "curried-chicken-and-broccoli-casserole",
    title: "Curried Chicken And Broccoli Casserole",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/curried_chicken_broc__HR_crop.png",
    time: "60 mins",
    servings: 6,
    caloriesPerServing: 301,
    greenPercentage: 9,
    ingredients: [
      "1 pound broccoli florets",
      ".25 cup water",
      "1  can (10 3/4 ounces) reduced-sodium cream of mushroom soup",
      ".25 cup mayonnaise",
      "1 tablespoon lemon juice",
      "1.5 teaspoons curry powder",
      ".5 teaspoon salt",
      ".5 teaspoon ground black pepper",
      "1.5 pounds boneless, skinless chicken breasts, cut into bite-size chunks",
      ".25 cup shredded reduced-fat colby or swiss cheese",
    ],
    instructions: [
      'Preheat the oven to 350\u00b0F. Coat a 13" x 9" baking dish with cooking spray.',
      "Place the broccoli and water in a large resealable plastic storage bag. Microwave on high power, rotating occasionally, for 3 to 5 minutes, or until bright green. Drain and set aside.",
      "In a small bowl, mix the soup, mayonnaise, lemon juice, curry powder, salt, and pepper. Stir to mix. Line the prepared baking dish with the reserved broccoli. Top with the chicken. Cover evenly with the soup mixture. Sprinkle with the cheese. Cover and bake for about 25 minutes. Uncover and bake for 15 to 20 minutes longer, or until golden and bubbling.",
    ],
    category: "dinner",
    week: "yumm",
  },
  {
    id: "greek-shrimp-with-tomatoes-and-feta",
    title: "Greek Shrimp with Tomatoes and Feta",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/Greek_shrimp_nofork_HR_crop.png",
    time: "19 mins",
    servings: 6,
    caloriesPerServing: 327,
    greenPercentage: 9,
    ingredients: [
      "2 tablespoons extra-virgin olive oil",
      ".5 cup prechopped onion",
      "1 tablespoon preminced oil-packed garlic",
      "1 can (15 ounces) diced tomatoes",
      "1 teaspoon dried oregano",
      ".25 teaspoon salt",
      ".5 teaspoon ground black pepper",
      "2 pounds peeled, deveined medium or large shrimp",
      "1.5 cups (6 ounces) precrumbled feta cheese",
    ],
    instructions: [
      "In a large skillet, heat the oil, onion, and garlic over medium-high heat. Cook, stirring occasionally, for 4 minutes, or until golden. Add the tomatoes (with juice), oregano, salt, and pepper. Cover and reduce the heat to medium-low. Simmer for 5 minutes. Add the shrimp. Toss to coat with the sauce. Scatter the cheese on top. Cover and simmer for 4 to 5 minutes, or until the shrimp are opaque.",
    ],
    category: "dinner",
    week: "yumm",
  },
  {
    id: "salmon-with-tabbouleh-salad",
    title: "Salmon with Tabbouleh Salad",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/salmon-with-tabbouleh-salad.jpg",
    time: "30 mins",
    servings: 4,
    caloriesPerServing: 319,
    greenPercentage: 15,
    ingredients: [
      "3 cups water",
      "1 cup bulgur",
      "1 lb. skinless salmon, cut into 4 fillets",
      "1 tsp. salt",
      "1/2 tsp. pepper",
      "1 small red onion",
      "2 tbsp. white-wine vinegar",
      "1 tbsp. extra-virgin olive oil",
      "1 cup mixed baby salad greens",
      "4 plum tomatoes",
      "1 bunch fresh basil",
      "8 pitted black olives",
    ],
    instructions: [
      "Quarter the tomatoes and halve the olives. Halve and thinly slice the onion. Chop enough basil to yield 1/3 cup. If unwashed, wash and dry the salad greens.",
      "Bring the water to a boil. Turn off the heat, add the bulgur and cover. Set aside until the bulgur is softened, about 30 minutes. After 30 minutes, drain well to remove all excess water.",
      "While the bulgur rests, sprinkle the salmon with 1/2 tsp. each salt and pepper. Spray a large, nonstick skillet with cooking spray and warm over medium-high heat. Add the salmon and cook until just opaque in the center, about 3 minutes on each side. Transfer the salmon to a plate and let cool to room temperature.",
      "Combine the red onion, vinegar, oil, and the remaining 1/2 tsp. of salt in a large bowl. Add the bulgur, salad greens, tomato, basil, and olives; toss to coat well. Divide the salad between plates and top each with a salmon fillet.",
    ],
    category: "dinner",
    week: "yumm",
  },
  {
    id: "chicken-and-avocado-pita-pockets",
    title: "Chicken and Avocado Pita Pockets",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2013-05-30/Chicken-and-Avocado-Pita-Pockets.jpg",
    time: "15 mins",
    servings: 4,
    caloriesPerServing: 588,
    greenPercentage: 31,
    ingredients: [
      "1 pound cooked chicken breast, cut into 1/2-inch pieces",
      "1/4 cup shredded reduced fat-cheddar cheese",
      "3/4 cup diced avocado",
      "1/2 cup seeded, chopped bell peppers, any color",
      "1/2 cup chopped celery",
      "1/2 cup unpeeled chopped cucumber",
      "1/2 cup peeled, shredded carrots",
      "1/2 cup finely chopped cauliflowerettes",
      "1/4 cup chopped red onions",
      "6 tablespoons Balsamic Dressing",
      '4 6" whole-wheat pitas, cut in half',
    ],
    instructions: [
      "Toss  the chicken, cheddar, and vegetables with the dressing. Fill each pita half with approximately 3/4 cup of the chicken mixture.",
    ],
    category: "dinner",
    week: "yumm",
  },
  {
    id: "heartland-pork-potato-and-apple-bake",
    title: "Heartland Pork, Potato, and Apple Bake",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/Heartland_Pork_HR_crop.png",
    time: "60 mins",
    servings: 6,
    caloriesPerServing: 269,
    greenPercentage: 23,
    ingredients: [
      "1.25 pounds premarinated peppercorn pork tenderloin",
      "1 pound (4 cups) frozen French onion oven-roast potatoes",
      "1 cup chunky unsweetened applesauce",
      "2  apples, cored, cut into walnut-size chunks",
      "2 tablespoons stone-ground mustard",
    ],
    instructions: [
      'Preheat the oven to 375\u00b0F. Coat a 17" x 11" baking pan or other large shallow baking pan with cooking spray.',
      "Place the pork, potatoes, applesauce, and apples in the pan. Toss to coat with the applesauce. Clear a diagonal strip in the center of the pan. Place the pork in the cleared space.",
      "Bake for about 45 minutes, or until a thermometer inserted into the center of the pork reaches 155\u00b0F and the juices run clear. Remove the pork to a cutting board. Let stand for 10 minutes.",
      "Cut the pork into thin slices. Stir the mustard into the potato-apple mixture.",
    ],
    category: "dinner",
    week: "yumm",
  },
  {
    id: "Three Bean and Turkey Chili",
    title: "Three Bean and Turkey Chili",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/turkey_chili_HR_crop.png",
    time: "35 mins",
    servings: 8,
    caloriesPerServing: 279,
    greenPercentage: 5,
    ingredients: [
      "2 tablespoons olive oil",
      "1 pound lean ground turkey breast",
      "1 package (1 ounce) reduced-sodium taco seasoning",
      "1 cup corn",
      "1 can (15 ounces) black beans, rinsed and drained",
      "1 can (15 ounces) northern beans, rinsed and drained",
      "1 can (15 ounces) pinto beans, rinsed and drained",
      "1 can (16 ounces) reduced-sodium chicken broth",
      "2 cans (14 1/2 ounces each) tomatoes with chiles, with juice",
      "hot sauce (optional)",
    ],
    instructions: [
      "Spray a 6- to 8-quart pot with nonstick spray. Warm the oil in the pot over medium-high heat. When the oil's hot, add the turkey and cook for 5 minutes, or until it's no longer pink. Add the taco seasoning and stir until the meat is well coated with the seasoning. Add the corn, beans, broth, and tomatoes. Bring to a boil. Reduce the heat to medium low and simmer, uncovered, for 20 minutes. Season to taste with hot sauce, if using.",
    ],
    category: "dinner",
    week: "yumm",
  },
  {
    id: "marinated-pork-chops-with-rosemary",
    title: "Marinated Pork Chops with Rosemary",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/marinated_pork_chops_HR_crop.png",
    time: "75 mins",
    servings: 4,
    caloriesPerServing: 429,
    greenPercentage: 3,
    ingredients: [
      ".333 cup olive oil",
      ".333 cup dry red wine",
      "3 tablespoons red wine vinegar",
      "5  large cloves garlic, pressed",
      "4  green onions, sliced",
      "2 tablespoons chopped fresh rosemary",
      "salt",
      "ground black pepper",
      "4  bone-in pork chops, each about 6 ounces",
    ],
    instructions: [
      "Whisk the oil, wine, vinegar, garlic, green onions, and rosemary together. Season to taste with salt and pepper. Put the pork chops in a glass baking dish and cover with the marinade. Refrigerate for 1 to 4 hours.",
      "Coat a grill pan with cooking spray, and cook the chops for about 5 minutes per side, or until a thermometer inserted in the center registers 145\u00b0F. Garnish with sprigs of rosemary before serving.",
    ],
    category: "dinner",
    week: "guac",
  },
  {
    id: "minestrone",
    title: "Minestrone",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2013-05-30/Minestrone.jpg",
    time: "45 mins",
    servings: 4,
    caloriesPerServing: 204,
    greenPercentage: 61,
    ingredients: [
      "2 teaspoons olive oil",
      "1 cup chopped onions",
      "1 cup peeled, shredded carrots",
      "1 1/2 cups low-sodium vegetable juice",
      "3 cups vegetable broth",
      "1 1/4 cups cored, diced tomatoes",
      "3/4 teaspoon dried thyme",
      "1 teaspoon dried oregano",
      "Freshly ground black pepper",
      "3 ounces dry, whole-wheat small pasta shells, or other whole-wheat small pasta shapes",
      "1 cup canned cannellini beans, rinsed and drained",
      "3 cups shredded fresh spinach",
    ],
    instructions: [
      "Heat the oil in a 4-5 quart pan over medium heat. Add the onions and carrots and cook 5 minutes, stirring occasionally.",
      "Add one cup water, vegetable juice, broth, tomatoes, thyme, oregano, and a few grindings of pepper. Bring the soup to a boil, reduce the heat, and simmer, covered, 30 minutes.",
      "Prepare pasta according to package directions.",
      "Add the cooked pasta, beans, and spinach and cook over medium-low heat for 10 minutes.",
    ],
    category: "dinner",
    week: "guac",
  },
  {
    id: "healthier-ham-and-cheese-frittata",
    title: "Healthier Ham and Cheese Frittata",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/asparagus%2C-ham-and-gruyere-frittata.jpg",
    time: "30 mins",
    servings: 6,
    caloriesPerServing: 287,
    greenPercentage: 11,
    ingredients: [
      "12 large eggs",
      "3 tbsp. 1% milk",
      "Salt and pepper to taste",
      "3 oz. Gruyere or Swiss cheese",
      "2 tsp. olive oil",
      "1/2 bunch asparagus",
      "4 ounces thick-sliced deli ham",
      "1 shallot",
    ],
    instructions: [
      'Adjust top oven rack to about 5" from broiler element, and preheat broiler. Break off the tough ends of the asparagus and cut into 1-inch pieces. Chop the ham and cut the cheese into 1/2-inch cubes. Mince the shallot.',
      "Whisk eggs, milk, 1/2 tsp. salt, and 1/4 tsp. pepper together. then stir in cheese; set aside.",
      "Heat oil in a large, oven-safe pan over medium heat. Add asparagus and cook until lightly browned and crisp-tender, 2 to 4 minutes. Stir in ham and shallot and cook until shallot softens, about 2 minutes.",
      "Add egg mixture to skillet and cook, using rubber spatula to stir and scrape bottom of skillet about 2 minutes; eggs should start to resemble scrambled eggs but still be very loose. Shake skillet to distribute eggs evenly and continue to cook without stirring to set the bottom, about 30 seconds.",
      "Slide skillet under broiler and cook until surface is puffed and spotty brown, yet center remains slightly wet and runny when cut into with paring knife, 3 to 4 minutes",
      "Remove skillet from broiler and let stand until eggs in middle are just set, about 5 minutes. Use rubber spatula to loosen frittata from skillet, then slide onto cutting board, slice into wedges, and serve.",
    ],
    category: "dinner",
    week: "guac",
  },
  {
    id: "chicken-stir-fry-with-salsa",
    title: "Chicken Stir-Fry with Salsa",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/salsa_stir_fry_HR_crop.png",
    time: "22 mins",
    servings: 4,
    caloriesPerServing: 241,
    greenPercentage: 12,
    ingredients: [
      "1 pound boneless, skinless chicken breasts,cut into thin strips",
      ".5  onion, thinly sliced",
      "1  clove garlic, minced",
      ".5  red pepper, thinly sliced",
      "1 cup broccoli florets",
      "1 cup salsa",
      "salt",
      "ground black pepper",
      ".25 teaspoon ground red pepper (optional)",
    ],
    instructions: [
      "In a large nonstick skillet over medium heat, cook the chicken, stirring frequently, until it is no longer pink and the juices run clear. Remove the chicken from the pan. In the same pan, cook the onion, garlic, pepper, and broccoli until crisp-tender. Return the chicken to the pan. Add the salsa and stir to coat. Cook for 1 or 2 minutes. Season to taste with salt, pepper, and red pepper, if using. Serve immediately.",
    ],
    category: "dinner",
    week: "guac",
  },
  {
    id: "shrimp-coconut-curry",
    title: "Shrimp-Coconut Curry",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/shrimp_curry_HR_crop.png",
    time: "45 mins",
    servings: 4,
    caloriesPerServing: 438,
    greenPercentage: 34,
    ingredients: [
      "1 cup brown basmati rice",
      "1 tablespoon olive oil",
      "1.5 pounds large shrimp, peeled and deveined",
      "1 teaspoon grated fresh ginger",
      "1  clove garlic, minced",
      "1 cup finely chopped red bell pepper",
      "1 cup chopped onion",
      "1 teaspoon Thai green curry paste",
      "1 can (13 1/2 ounces) light coconut milk",
      "3 teaspoons fish sauce",
      "1 tablespoon packed brown sugar",
      "2 tablespoons chopped fresh cilantro",
    ],
    instructions: [
      "Cook the rice according to package directions. Fluff the rice with a fork.",
      "Meanwhile, heat 2 teaspoons of the oil in a large nonstick skillet over medium-high heat. Add the shrimp and cook for 2 to 3 minutes per side, or until lightly browned and opaque. Transfer the shrimp to a bowl and reserve. Heat the remaining 1 teaspoon oil in the skillet, add the ginger and garlic, and cook for 30 seconds, or until fragrant. Add the bell pepper and onion and cook for 3 minutes. Stir in the curry paste and cook, stirring often, for 1 minute.",
      "Reduce the heat to medium and add the coconut milk, fish sauce, and sugar. Cook for 3 minutes, stirring occasionally, until heated through. Add the shrimp and cook for 1 minute longer, or until hot. Remove from the heat and stir in the cilantro. Serve over rice.",
    ],
    category: "dinner",
    week: "guac",
  },
  {
    id: "tofu-pad-thai",
    title: "Tofu Pad Thai",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2013-05-30/Tofu-Pad-Thai.jpg",
    time: "30 mins",
    servings: 4,
    caloriesPerServing: 328,
    greenPercentage: 37,
    ingredients: [
      "6 ounces Asian rice noodles",
      "1 cup vegetable broth",
      "2 tablespoons bottled fish sauce",
      "1 tablespoon rice-wine vinegar",
      "1 tablespoon lime juice",
      "3 tablespoons tomato paste",
      "1 tablespoon sugar",
      "1/2 tablespoon seeded, minced jalapeno",
      "1 tablespoon peanut oil",
      "1 teaspoon garlic",
      "1 egg",
      "8 ounces extra-firm tofu, diced into 1/4 inch cubes",
      "1 cup chopped onions",
      "2 1/2 cups fresh bean sprouts",
      "1/2 cup chopped fresh cilantro",
      "1/4 cup chopped, dry-roasted peanuts",
      "4 cups shredded romaine lettuce",
    ],
    instructions: [
      "Prepare the noodles as directed on the package",
      "In a large nonstick skillet or a wok, heat the oil over medium heat and saute the garlic. Add the egg and scramble it into small pieces. Increase the heat to high, add the tofu, and saute 2 minutes, stirring gently. Add the sauce mixture and cook 1 minute, or until it comes to a boil.",
      "Reduce the heat to a medium, and add the rice noodles, onions, sprouts, cilantro, and peanuts to the skillet. Heat thoroughly while tossing until the noodles are coated.",
      "Divide the romaine among 4 plates and serve the Pad Thai over it.",
    ],
    category: "dinner",
    week: "guac",
  },
  {
    id: "leftover-turkey-and-vegetable-hash",
    title: "Leftover Turkey and Vegetable Hash",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2013-12-05/turkey_hash.jpg",
    time: "45 mins",
    servings: 4,
    caloriesPerServing: 373,
    greenPercentage: 31,
    ingredients: [
      "1 medium onion, diced",
      "4 cloves garlic, minced",
      "1  medium carrot, diced",
      "1 cup brussels sprouts, chopped",
      "1 cup yellow or green squash, chopped",
      "2 cups potatoes, chopped",
      "2 cups leftover turkey, white meat chopped",
      "1 tbsp. rosemary, chopped",
      "1 tbsp. thyme, chopped",
      "salt and pepper to taste",
      "cooking spray",
    ],
    instructions: [
      "Preheat oven to 425 degrees. Spray cooking spray on a roasting pan or baking sheet. Place carrots, potatoes, and brussels sprouts in a single layer. Roast for 25 to 30 minutes, turning occasionally to brown on all sides. Take out and set aside.",
      "Heat a medium-sized pan over medium heat and spray with cooking spray. Saute the onion and garlic for about 3 minutes. Add roasted carrots, potatoes, brussels sprouts, along with squash and cook for another 5 minutes.",
      "Add thyme, rosemary and chopped turkey and cook for about 10 minutes. All veggies should be slightly browned. Season with salt and pepper.",
    ],
    category: "dinner",
    week: "eats",
  },
  {
    id: "lean-pork-lettuce-wraps",
    title: "Lean Pork Lettuce Wraps",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/Lean-Pork-Lettuce-Wraps.jpg",
    time: "40 mins",
    servings: 2,
    caloriesPerServing: 507,
    greenPercentage: 50,
    ingredients: [
      "½ cup uncooked whole grain rice",
      "1 tbsp. minced fresh ginger",
      "6 cloves garlic",
      "8 oz. lean ground pork or chicken*",
      "1 head of Boston bibb lettuce",
      "1 small red bell pepper",
      "1 small cucumber",
      "2 carrots",
      "4 oz. button mushrooms",
      "1 jalapeno",
      "1 lime",
      "1 tbsp. soy sauce",
      "1 tsp. brown sugar",
    ],
    instructions: [
      "Cook rice according to package instructions, omitting any fat. Mince the ginger and garlic and combine with the pork. Mix gently with your fingers just enough to distribute the garlic and ginger throughout the pork. Set aside.",
      "Halve the head of lettuce and separate the leaves. Rinse well and set aside to dry. Dice the bell pepper and mince about half of the jalapeno (remove seeds to reduce heat). Cut the cucumber in half and scrape out the seeds with a spoon; dice the remaining cucumber. Slice the mushrooms and peel and dice the carrots. Cut the lime in half and juice.",
      "Heat a large nonstick skillet over medium-high heat (the nonstick coating allows you to skip the oil). Add the pork mixture to the pan and brown, crumbling with a spoon as it cooks. When browned, about 5-7 minutes, transfer the pork and its juices to a large clean mixing bowl, and return the pan the stove over medium-low heat.",
      "Whisk together the soy sauce, sugar, and lime juice until the sugar is dissolved. Add to the pork mixture.",
      "Add the cucumber, peppers, carrots, and mushrooms to the hot pan and saute for a minute or less, just enough to warm through. Add to the bowl with the pork and mix together.",
      "Separate the two servings of pork mixture, lettuce, and rice onto two plates, but let everyone assemble their own lettuce wraps as you eat — that's half the fun!",
    ],
    category: "dinner",
    week: "eats",
  },
  {
    id: "curried-chicken-and-vegetable-soup",
    title: "Curried Chicken and Vegetable Soup",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/curried-chicken-and-vegetable-soup.jpg",
    time: "60 mins",
    servings: 6,
    caloriesPerServing: 285,
    greenPercentage: 62,
    ingredients: [
      "2 tsp. canola oil",
      "1 leek",
      "3 cloves garlic",
      "1 tbsp. curry powder",
      "48 oz. reduced-sodium chicken broth",
      "2 large red potatoes scrubbed and diced",
      "2 carrots",
      "2 cups small cauliflower florets (purchase pre-cut or cut your own)",
      "3/4 pound skinless, boneless chicken thighs, cut into 1/2 inch chunks",
      "1 tsp. garam masala",
      "1/4 tsp. salt",
      "1/4 cup plain, fat-free Greek yogurt",
    ],
    instructions: [
      "Clean and dice potatoes. Clean and thinly slice the leek, white and light green portions only. (If you're not familiar with cleaning leeks, try watching a how-to video online.) Mince the garlic and cut the chicken into 1/2-inch cubes.",
      "Heat the oil in a large nonstick pot or Dutch oven over medium heat. Add the leek and garlic; cook, stirring occasionally, until golden, 7-10 minutes. Add the curry powder and cook, stirring constantly, until fragrant, about 1 minute. Stir in the broth, potatoes, carrots, and cauliflower; bring to a boil. Reduce the heat and simmer about 15 minutes or until veggies are tender.",
      "Stir in the chicken, cilantro, garam masala, and salt. Return the soup to a boil. Reduce the heat and simmer, covered, until the chicken is cooked through, about 10 minutes. Divide the soup between bowls and top each with a dollop of Greek yogurt.",
    ],
    category: "dinner",
    week: "eats",
  },
  {
    id: "the-easiest-meat-loaf",
    title: "The Easiest Meat Loaf",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/meatloaf__HR_crop.png",
    time: "60 mins",
    servings: 6,
    caloriesPerServing: 553,
    greenPercentage: 3,
    ingredients: [
      ".5 cup whole milk",
      "1  egg, beaten",
      "1 teaspoon dried thyme",
      "1.5 teaspoons salt",
      "1.5 teaspoons ground black pepper",
      "2 pounds ground round beef",
      "1 pound ground pork",
      "1.5 cups coarsely crumbled day-old Italian bread",
      "1 cup chopped fresh parsley",
      "2 tablespoons preminced oil-packed garlic",
      "2 teaspoons vegetable oil",
      "1 jar (12 ounces) prepared beef gravy (optional)",
    ],
    instructions: [
      'Preheat the oven to 350\u00b0F. Coat a 17" x 11" baking pan or other large shallow baking pan with cooking spray. Line the pan with plastic wrap.',
      "In a measuring cup, beat the milk, egg, thyme, salt, and pepper with a fork. Set aside. Place the beef, pork, bread crumbs, parsley, and garlic in the center of the prepared pan. With hands,",
      'combine the meat mixture until well mixed. Gradually drizzle in the milk mixture while mixing with the other hand until all of the liquid is absorbed. Shape the mixture into two loaves, about 9" x 5", parallel with the shorter side of the pan. Cut the plastic sheet in half between the loaves. Either pull the plastic sheets out from under the loaves or flip each loaf upside down to remove the plastic. Position the loaves at least 5" apart. Drizzle 1 teaspoon of the oil over each of the loaves.Bake for about 50 minutes, or until a thermometer inserted horizontally into the center registers',
      "160\u00b0F and the meat is no longer pink. Let stand 15 minutes before slicing. Cut off three-quarters of 1 meat loaf (1 pound). Transfer to a plate. Allow to cool completely. Place in a zipper-lock bag and refrigerate for up to 3 days for later use or use in another recipe. Serve meat loaf with prepared gravy, if desired.",
    ],
    category: "dinner",
    week: "eats",
  },
  {
    id: "Shrimp Biryani",
    title: "Shrimp Biryani",
    image: "https://s3.amazonaws.com/noom-app/recipe-images/Shrimp-Biryani.jpg",
    time: "45 mins",
    servings: 4,
    caloriesPerServing: 353,
    greenPercentage: 87,
    ingredients: [
      "½ cup uncooked brown basmati rice (if you can't find brown basmati, any whole-grain rice will do)",
      "1 tbsp. olive oil",
      "½ yellow onion",
      "1 clove garlic",
      "½ tbsp. minced fresh ginger",
      "¼ tsp. ground coriander",
      "1 tsp. curry powder",
      "Pinch of cayenne, or to taste",
      "1 small potato",
      "1 carrot",
      "½ tsp. salt",
      "1 cup uncooked, peeled, deveined shrimp",
      "½ 10 oz. bag of frozen peas, thawed",
      "14.5 oz can diced tomatoes",
      "4 tbsp. 0% Greek yogurt",
      "Small handful cilantro",
      "1 jalapeno, optional",
    ],
    instructions: [
      "Prepare the rice according to package instructions, eliminating any fat. Chop the onion, mince the garlic and ginger. Cut the potato into roughly 1-inch by 1-inch cubes, leaving the skin intact. Peel the carrot and roughly chop.",
      "Heat the oil in a large pan over medium-high heat. When hot, add the onion and cook for about 5 minutes. Once the onion is translucent, add the ginger and garlic, and stir together. After about 1 minute, add the dry spices, stir to combine and cook for about another minute.",
      "Add about 1 cup of water to the pan, then add the potatoes and carrots. Bring the mixture to a boil, then reduce the heat and let simmer for about 10 to 15 minute, or until the potatoes are tender when pricked with a fork.",
      "About 5 minutes before the potatoes are done cooking, add the shrimp. Stir after 2-3 minutes to cook evenly on both sides. At the end of the cooking time, there should be little to no water remaining.",
      "Stir the peas and tomatoes into the veggie mixture and warm through (no more than a minute or two). Remove the pan from the heat and add the rice and yogurt. Mix everything together well.",
      "Serve the biryani topped with cilantro and jalapeno, if desired.",
    ],
    category: "dinner",
    week: "eats",
  },
  {
    id: "bow-tie-pasta-with-spinach-tomato-and-olives",
    title: "Bow Tie Pasta with Spinach, Tomato, and Olives",
    image:
      "https://s3.amazonaws.com/noom-app/recipe-images/2014-11-03/bow_tie_pasta_wcheese__HR_crop.png",
    time: "20 mins",
    servings: 4,
    caloriesPerServing: 429,
    greenPercentage: 9,
    ingredients: [
      "12 ounces bow tie pasta",
      "2 tablespoons olive oil",
      "2  cloves garlic, finely chopped",
      "2 cups chopped fresh or canned tomato",
      "2 cups packed (2 ounces) baby spinach leaves, roughly chopped",
      "2 tablespoons lemon juice, preferably freshly squeezed",
      "2 tablespoons sliced kalamata or other ripe olives (about 5 to 6 olives)",
      "2 tablespoons capers, drained and rinsed",
      ".25 teaspoon ground black pepper",
      ".125 teaspoon salt",
      "2 tablespoons grated Parmesan cheese",
    ],
    instructions: [
      "Cook the pasta according to the package directions. Before draining, scoop out 1/2 cup of the pasta-cooking water and reserve. Drain the pasta and return it to the cooking pot to keep warm.",
      "Meanwhile, in a large, nonstick skillet over medium-low heat, combine the oil and garlic. Cook for about 2 minutes, or until the garlic is soft and fragrant. Do not brown. Add the tomato and cook for about 4 minutes longer, or until the tomato starts to soften. Add the spinach and cook, tossing, for about 1 minute more, or until wilted. Stir in the lemon juice, olives, capers, pepper, and salt. Reduce the heat to low.",
      "Add the tomato mixture to the reserved pasta and toss to coat. Add a few tablespoons of the reserved cooking water, if needed, to moisten the pasta.",
      "Serve sprinkled with cheese.",
    ],
    category: "dinner",
    week: "eats",
  },
];
